<script>
export default {
  name: 'SupportCallbackResult',
  props: {
    status: {
      type: String,
      default: '',
    },
  },
  computed: {
    isSuccess() {
      return this.status === 'success'
    },
    iconName() {
      return this.isSuccess ? 'check-success' : 'failed'
    },
    title() {
      return this.isSuccess
        ? this.$t('sidebar_support_widget_callback_request_sent_title')
        : this.$t('sidebar_support_widget_callback_request_failed_title')
    },
    description() {
      return this.isSuccess
        ? this.$t('sidebar_support_widget_callback_request_sent_description')
        : this.$t('sidebar_support_widget_callback_request_failed_description')
    },
  },
}
</script>

<template>
  <div class="support-callback-result">
    <div class="support-callback-result__icon">
      <svg-icon :name="iconName" width="84px" height="84px" />
    </div>
    <div class="support-callback-result__content">
      <div class="tamara-english-heading-4">
        {{ title }}
      </div>
      <div class="tamara-english-regular-2">
        {{ description }}
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.support-callback-result {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  &__content {
    display: flex;
    flex-direction: column;
    gap: 5px;
    align-items: center;
    margin-top: 24px;
  }
}
</style>
